var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcLike = function SvgIcLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59961 17.8009C5.02136 17.8072 5.44044 17.8691 5.84602 17.9849L8.75324 18.8153C9.18173 18.9378 9.6252 19 10.0708 19.0001H13.9789C15.1688 19.0001 16.3164 18.5582 17.1989 17.7599C18.0814 16.9617 18.6359 15.8641 18.7549 14.6801L18.9949 10.6001C19.0374 9.76724 18.7894 8.9455 18.2933 8.2752C17.7972 7.6049 17.0838 7.12761 16.2749 6.92484L15.1109 6.67044C14.8507 6.60594 14.6197 6.45619 14.4545 6.24509C14.2894 6.03398 14.1997 5.77366 14.1997 5.50563V2.80001C14.1997 2.32262 14.01 1.86478 13.6725 1.52721C13.3349 1.18964 12.8771 1 12.3997 1C11.9223 1 11.4644 1.18964 11.1269 1.52721C10.7893 1.86478 10.5997 2.32262 10.5997 2.80001V4.04322C10.5997 5.63453 9.96751 7.16067 8.84228 8.28589C7.71705 9.41112 6.19092 10.0433 4.59961 10.0433V17.8009Z",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.2002H4.60003V19.0003H1V8.2002Z",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_like.c57f2aa1.svg";
export { ForwardRef as ReactComponent };